import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from '../../settings/general-catalog-select.service';

export interface CompanyClassSelectOption {
  value: string;
  label: string;
  /** Código de negocio (ej. CON, INT). */
  code: string;
}

/**
 * Catálogo de clases de empresa (`company_class`).
 * Via select unificado: general-catalogs → lists.
 */
@Injectable({ providedIn: 'root' })
export class CompanyClassSelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<CompanyClassSelectOption[]> {
    return this.generalCatalogSelect
      .getListOptionsByPrefix('company_class')
      .pipe(
        map((options) =>
          options.map((o) => ({
            value: o.value,
            label: o.label,
            code: String(o.code ?? '').trim(),
          })),
        ),
      );
  }
}
